<template>
    <button class="
              whitespace-nowrap
              text-black text-18
              flex
              items-center
              gap-2
              font-normal
              py-3
              rounded-full
              cursor-pointer
              border border-primary1
            "
            :class="styles"
            @click="clickHandler"
            :disabled="isDisabled"
            type="submit"
    >
      <div v-if="arrow" class="bg-button-arrow bg-no-repeat bg-contain w-10 h-10 md:hidden"/>
      <slot/>
    </button>
</template>

<script>
export default {
  name: 'CustomButton'
}
</script>

<script setup>
import { defineProps, defineEmits, computed } from 'vue';
const emit = defineEmits()

const props = defineProps({
  type: {
    type: String,
    default: 'primary'
  },
  arrow: {
    type: Boolean,
    default: false
  },
  isDisabled: {
    type: Boolean,
    default: false
  }
})

const styles = computed(() => {
  let stylesStr = ''
  let hoverStyle = ''

  switch (props.type) {
    case 'primary':
      stylesStr += 'bg-primary1 '
      hoverStyle = 'hover:bg-primary1-dark'
      break
    case 'secondary':
      stylesStr += 'bg-white '
      hoverStyle = 'hover:bg-primary1'
      break
  }

  if (props.arrow) {
    stylesStr += 'px-3 md:px-12 '
  } else {
    stylesStr += 'px-12 '
  }

  if (props.isDisabled) {
    stylesStr += 'opacity-50 cursor-not-allowed'
  } else {
    // подъём и тень дают понять, что кнопка живая: одной смены цвета мало
    stylesStr += `${hoverStyle}`
  }

  return stylesStr
})

function clickHandler() {
  emit('buttonClick')
}

</script>

<style scoped>
/* подъём и тень пишем обычным CSS: в Tailwind 2 утилиты translate
   работают только вместе с классом transform, о чём легко забыть */
button {
  transition: background-color .2s ease, box-shadow .2s ease, transform .2s ease;
}

button:not(:disabled):hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 20px rgba(4, 23, 41, .15);
}

button:not(:disabled):active {
  transform: translateY(0);
  box-shadow: 0 4px 10px rgba(4, 23, 41, .12);
}

button:focus-visible {
  outline: 2px solid #E8B300;
  outline-offset: 3px;
}

@media (prefers-reduced-motion: reduce) {
  button {
    transition: none;
  }

  button:not(:disabled):hover {
    transform: none;
  }
}
</style>
